export default function usePhoneTranslations() {
  const phoneCategories = {
    "M": "Mobile",
    "P": "Office"
  };

  return { phoneCategories };
}